import { selectTextField as ie, isItem as j, focusSilently as se, getEnabledItem as ue } from "./5VQZOHHZ.js";
import { useCollectionItem as ae } from "./Y62RTBST.js";
import { useCompositeContext as le, CompositeRowContext as fe, CompositeItemContext as ce } from "./APTFW6PT.js";
import { useCommand as de } from "./2W3RN7C5.js";
import { useStoreStateObject as me } from "./RTNCFSKZ.js";
import { createHook as pe, memo as be, forwardRef as Ie, createElement as ge } from "./VOQWLFSQ.js";
import { useId as ve, useEvent as T, useBooleanEvent as N, useWrapElement as we, useMergeRefs as Pe } from "./5GGHRIN3.js";
import { __objRest as Se, __spreadProps as S, __spreadValues as x } from "./3YLGPPWQ.js";
import { isTextbox as D, getTextboxSelection as xe, getTextboxValue as he, isTextField as Ce, isButton as Ee, getScrollingElement as ye } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
import { isPortalEvent as Te, isSelfTarget as R } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/events.js";
import { disabledFromProps as De, removeUndefinedValues as Re } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { isSafari as Ae } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/QAGXQEUG.js";
import { useRef as V, useContext as Oe, useCallback as ke, useMemo as ze } from "react";
import { jsx as Ke } from "react/jsx-runtime";
var Fe = "button";
function _e(o) {
  return D(o) ? !0 : o.tagName === "INPUT" && !Ee(o);
}
function Be(o, a = !1) {
  const u = o.clientHeight, { top: t } = o.getBoundingClientRect(), c = Math.max(u * 0.875, u - 40) * 1.5, m = a ? u - c + t : c + t;
  return o.tagName === "HTML" ? m + o.scrollTop : m;
}
function He(o, a = !1) {
  const { top: u } = o.getBoundingClientRect();
  return a ? u + o.clientHeight : u;
}
function L(o, a, u, t = !1) {
  var c;
  if (!a || !u) return;
  const { renderedItems: m } = a.getState(), v = ye(o);
  if (!v) return;
  const h = Be(v, t);
  let f, p;
  for (let b = 0; b < m.length; b += 1) {
    const r = f;
    if (f = u(b), !f) break;
    if (f === r) continue;
    const w = (c = ue(a, f)) == null ? void 0 : c.element;
    if (!w) continue;
    const I = He(w, t) - h, s = Math.abs(I);
    if (t && I <= 0 || !t && I >= 0) {
      p !== void 0 && p < s && (f = r);
      break;
    }
    p = s;
  }
  return f;
}
function Me(o, a) {
  return R(o) ? !1 : j(a, o.target);
}
var Ne = pe(
  function(a) {
    var u = a, {
      store: t,
      rowId: c,
      preventScrollOnKeyDown: m = !1,
      moveOnKeyPress: v = !0,
      tabbable: h = !1,
      getItem: f,
      "aria-setsize": p,
      "aria-posinset": b
    } = u, r = Se(u, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const w = le();
    t = t || w;
    const l = ve(r.id), I = V(null), s = Oe(fe), A = De(r) && !r.accessibleWhenDisabled, {
      rowId: C,
      baseElement: O,
      isActiveItem: U,
      ariaSetSize: W,
      ariaPosInSet: G,
      isTabbable: q
    } = me(t, {
      rowId(e) {
        if (c) return c;
        if (e && s != null && s.baseElement && s.baseElement === e.baseElement)
          return s.id;
      },
      baseElement(e) {
        return (e == null ? void 0 : e.baseElement) || void 0;
      },
      isActiveItem(e) {
        return !!e && e.activeId === l;
      },
      ariaSetSize(e) {
        if (p != null) return p;
        if (e && s != null && s.ariaSetSize && s.baseElement === e.baseElement)
          return s.ariaSetSize;
      },
      ariaPosInSet(e) {
        if (b != null) return b;
        if (!e || !(s != null && s.ariaPosInSet) || s.baseElement !== e.baseElement) return;
        const n = e.renderedItems.filter(
          (i) => i.rowId === C
        );
        return s.ariaPosInSet + n.findIndex((i) => i.id === l);
      },
      isTabbable(e) {
        if (!(e != null && e.renderedItems.length)) return !0;
        if (e.virtualFocus) return !1;
        if (h) return !0;
        if (e.activeId === null) return !1;
        const n = t == null ? void 0 : t.item(e.activeId);
        return n != null && n.disabled || !(n != null && n.element) ? !0 : e.activeId === l;
      }
    }), J = ke(
      (e) => {
        var n;
        const i = S(x({}, e), {
          id: l || e.id,
          rowId: C,
          disabled: !!A,
          children: (n = e.element) == null ? void 0 : n.textContent
        });
        return f ? f(i) : i;
      },
      [l, C, A, f]
    ), k = r.onFocus, E = V(!1), Q = T((e) => {
      if (k == null || k(e), e.defaultPrevented || Te(e) || !l || !t || Me(e, t)) return;
      const { virtualFocus: n, baseElement: i } = t.getState();
      if (t.setActiveId(l), D(e.currentTarget) && ie(e.currentTarget), !n || !R(e) || _e(e.currentTarget) || !(i != null && i.isConnected)) return;
      Ae() && e.currentTarget.hasAttribute("data-autofocus") && e.currentTarget.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      }), E.current = !0, e.relatedTarget === i || j(t, e.relatedTarget) ? se(i) : i.focus();
    }), z = r.onBlurCapture, X = T((e) => {
      if (z == null || z(e), e.defaultPrevented) return;
      const n = t == null ? void 0 : t.getState();
      n != null && n.virtualFocus && E.current && (E.current = !1, e.preventDefault(), e.stopPropagation());
    }), K = r.onKeyDown, Y = N(m), Z = N(v), $ = T((e) => {
      if (K == null || K(e), e.defaultPrevented || !R(e) || !t) return;
      const { currentTarget: n } = e, i = t.getState(), y = t.item(l), d = !!(y != null && y.rowId), P = i.orientation !== "horizontal", g = i.orientation !== "vertical", _ = () => !!(d || g || !i.baseElement || !Ce(i.baseElement)), B = {
        ArrowUp: (d || P) && t.up,
        ArrowRight: (d || g) && t.next,
        ArrowDown: (d || P) && t.down,
        ArrowLeft: (d || g) && t.previous,
        Home: () => {
          if (_())
            return !d || e.ctrlKey ? t == null ? void 0 : t.first() : t == null ? void 0 : t.previous(-1);
        },
        End: () => {
          if (_())
            return !d || e.ctrlKey ? t == null ? void 0 : t.last() : t == null ? void 0 : t.next(-1);
        },
        PageUp: () => L(n, t, t == null ? void 0 : t.up, !0),
        PageDown: () => L(n, t, t == null ? void 0 : t.down)
      }[e.key];
      if (B) {
        if (D(n)) {
          const M = xe(n), ee = g && e.key === "ArrowLeft", te = g && e.key === "ArrowRight", re = P && e.key === "ArrowUp", ne = P && e.key === "ArrowDown";
          if (te || ne) {
            const { length: oe } = he(n);
            if (M.end !== oe) return;
          } else if ((ee || re) && M.start !== 0) return;
        }
        const H = B();
        if (Y(e) || H !== void 0) {
          if (!Z(e)) return;
          e.preventDefault(), t.move(H);
        }
      }
    }), F = ze(
      () => ({ id: l, baseElement: O }),
      [l, O]
    );
    return r = we(
      r,
      (e) => /* @__PURE__ */ Ke(ce.Provider, { value: F, children: e }),
      [F]
    ), r = S(x({
      id: l,
      "data-active-item": U || void 0
    }, r), {
      ref: Pe(I, r.ref),
      tabIndex: q ? r.tabIndex : -1,
      onFocus: Q,
      onBlurCapture: X,
      onKeyDown: $
    }), r = de(r), r = ae(S(x({
      store: t
    }, r), {
      getItem: J,
      shouldRegisterItem: l ? r.shouldRegisterItem : !1
    })), Re(S(x({}, r), {
      "aria-setsize": W,
      "aria-posinset": G
    }));
  }
);
be(
  Ie(function(a) {
    const u = Ne(a);
    return ge(Fe, u);
  })
);
export {
  Ne as useCompositeItem
};
//# sourceMappingURL=SBSPVDDI.js.map
